// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  type ReferralBankDetails,
  type Currency
} from '../../../utilities/types';
import CryptoWalletsForm from './CryptoWalletsForm';
import SectionLoader from '../../../components/SectionLoader';
import { getCryptoCurrencies } from '../../../utilities/selectors';
import { loadCryptoWallets } from './reducer';

type Props = {
  loading: boolean,
  initialValues: $Exact<ReferralBankDetails>,
  cryptoCurrencies: Currency[],
  sidebarOpened: boolean,
  sidebarOpenedDevice: boolean,
  viewportDevice: boolean,
  loadCryptoWallets: () => void
};

class CryptoWallets extends Component<Props> {
  componentDidMount() {
    this.props.loadCryptoWallets();
  }

  render() {
    if (this.props.loading) {
      return <SectionLoader />;
    }

    return (
      <CryptoWalletsForm
        initialValues={this.props.initialValues}
        loading={this.props.loading}
        cryptoCurrencies={this.props.cryptoCurrencies}
        sidebarOpened={this.props.sidebarOpened}
        sidebarOpenedDevice={this.props.sidebarOpenedDevice}
        viewportDevice={this.props.viewportDevice}
      />
    );
  }
}

const mapStateToProps = state => ({
  initialValues: state.account.cryptoWallets.referralCryptoWallets,
  cryptoCurrencies: getCryptoCurrencies(state),
  sidebarOpened: state.global.sidebarOpened,
  sidebarOpenedDevice: state.global.sidebarOpenedDevice,
  viewportDevice: state.global.viewportDevice,
  loading: state.account.cryptoWallets.loading
});

const mapDispatchToProps = {
  loadCryptoWallets
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CryptoWallets);
